import { render, staticRenderFns } from "./FallingItemContent.vue?vue&type=template&id=071ca398&scoped=true&"
import script from "./FallingItemContent.vue?vue&type=script&lang=js&"
export * from "./FallingItemContent.vue?vue&type=script&lang=js&"
import style0 from "./FallingItemContent.vue?vue&type=style&index=0&id=071ca398&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071ca398",
  null
  
)

export default component.exports